import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadConfiguredViolationsFailed, loadConfiguredViolationsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadConfiguredViolations(action) {
  try {
    const {
      payload = {},
    } = action;
    const url = `${BACKEND_URL}/dashboard/load-configured-violations`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadConfiguredViolationsSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadConfiguredViolationsFailed());
      yield call(rejectActionPromise(action, data.data));
    }
  } catch (e) {
    yield put(loadConfiguredViolationsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
